import React, { Component } from "react";

import { Login } from "../../utils/consts";

import Button from "@atlaskit/button";
import ModalDialog, { ModalFooter } from "@atlaskit/modal-dialog";
import { FieldTextStateless } from "@atlaskit/field-text";
import { CheckboxStateless } from "@atlaskit/checkbox";
import * as EmailValidator from "email-validator";

import "./loginModal.css";
export default class LoginModal extends Component {
  constructor() {
    super();

    this.state = {
      email: "",
      acceptTerms: true,
      emailError: false
    };
  }

  checkboxHandler = () =>
    this.setState({ acceptTerms: !this.state.acceptTerms });

  emailFieldHandler = e => this.setState({ email: e.target.value });

  footer = () => (
    <ModalFooter>
      <Button
        className="login-modal__login-btn"
        onClick={this.login}
        appearance="primary"
        form={"login"}
        type="submit"
        shouldFitContainer={true}
      >
        Email Magic Link
      </Button>
    </ModalFooter>
  );

  validate = () =>
    this.setState({
      emailError: EmailValidator.validate(this.state.email)
    });

  login = () => {
    if (this.state.emailError) {
      console.log("error");
      return;
    }
    if (!EmailValidator.validate(this.state.email)) {
      console.log("error");
      return;
    }
    if (!this.state.acceptTerms) {
      console.log("error");
      return;
    }
    Login(this.state.email)
      .then(() => {
        this.props.loginOpenHandler();
        this.setState({ emailSent: true });
        //TODO: inform user that email has been sent
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    return (
      <ModalDialog
        onClose={this.props.loginOpenHandler}
        heading="Login"
        isChromeless={false}
        footer={this.footer}
        showKeyline={false}
        autoFocus={true}
        className="login-modal"
      >
        <FieldTextStateless
          shouldFitContainer
          label="Email Address"
          value={this.state.email}
          onChange={this.emailFieldHandler}
          className="login-modal__field-email"
          autoComplete="on"
          name="my-email"
          placeholder="Email address..."
          type="email"
          required={true}
          isInvalid={this.state.emailError}
        />
        <CheckboxStateless
          initiallyChecked
          isChecked={this.state.acceptTerms}
          name="accept-terms"
          label="I agree to the terms of service."
          onChange={this.checkboxHandler}
          value={this.state.acceptTerms}
        />
      </ModalDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginModal/LoginModal.js